{
  "ui": {
    "feedback": "Palaute",
    "credits": "Tekijät",
    "currentMaintainer": "Nykyinen ylläpitäjä",
    "maintainerPeriod": "Vuodesta 2026 alkaen",
    "originalTeam": "Alkuperäinen tiimi",
    "creditsCampaigns": "Viidakko ja joulu",
    "moreSettings": "Lisää asetuksia",
    "chooseLanguage": "Valitse kieli",
    "notebookTools": "Vihkon työkalut",
    "visualGuide": "Kuvaopas",
    "templeSoon": "Tulossa pian",
    "playAdventure": "Pelaa",
    "story": "Tarina",
    "loadingAdventure": "Valmistaudutaan seikkailuun…",
    "storyOpening": "Kouluretki viidakkoon. Marco ja Sophia tutkivat paikkoja ystäviensä kanssa. Värikäs lintu herättää Marcon huomion, ja hän seuraa sitä puiden väliin. Yhtäkkiä hän on yksin. Auta tutkimusmatkailijoita löytämään tie!",
    "storyEnding": "Marco ja Sophia saapuvat yhdessä kadonneeseen temppeliin. Salaperäiset kasvot vartioivat sisäänkäyntiä. Uusi seikkailu odottaa!",
    "blockCategories": "Vihkon välilehdet",
    "actions": "Toiminnot",
    "loops": "Silmukat",
    "conditions": "Ehdot",
    "title": "Run Marco! — Seikkailu vihkossasi",
    "home": "Run Marcon etusivu",
    "map": "Seikkailukartta",
    "worlds": "Valitse seikkailu",
    "notebook": "Minun vihkoni",
    "notebookToggle": "Avaa tai sulje vihko",
    "notebookOpen": "Avaa vihko",
    "notebookClose": "Katso polkua",
    "page": "Sivu {number}",
    "level": "Reitti {number}",
    "run": "Mennään!",
    "stop": "Pysäytä",
    "step": "Yksi askel",
    "stepTitle": "Suorita yksi ohje",
    "reset": "Takaisin alkuun",
    "add": "Lisää",
    "addLabel": "Valitse lisättävä palikka",
    "addHint": "Yhdistä palikat ja paina Pelaa.",
    "undo": "Kumoa",
    "clear": "Uusi sivu",
    "hint": "Pieni vihje",
    "help": "Peliohjeet",
    "settings": "Asetukset",
    "language": "Pelin kieli",
    "blockLanguage": "Palikoiden kieli",
    "blockLanguageNote": "Voit valita palikoille eri kielen.",
    "musicOn": "Ääni päälle",
    "musicOff": "Ääni pois",
    "sound": "Musiikki ja äänitehosteet",
    "speed": "Seikkailun nopeus",
    "chooseExplorer": "Valitse tutkimusmatkailija",
    "explorer": "Tutkimusmatkailija",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Sulje",
    "done": "Lähdetään tutkimaan!",
    "loading": "Etsitään polkua…",
    "loadError": "Seikkailua ei voitu ladata. Yritä uudelleen lataamalla sivu uudelleen.",
    "imageError": "Joitakin kuvia ei voitu ladata. Lataa sivu uudelleen.",
    "gemGoal": "Etsi jalokivi",
    "goal": "Etsi kultainen tähti",
    "cover": "Sytytä jokainen ruutu vain kerran",
    "lit": "{count} / {total} ruutua sytytetty",
    "explored": "{count} / {total} reittiä tutkittu",
    "facing": "Katsoo {direction} {arrow}",
    "boardLabel": "{name} reitillä {level}, katsoo {direction}. {steps}. {objective}.",
    "up": "ylös",
    "down": "alas",
    "left": "vasemmalle",
    "right": "oikealle",
    "steps_one": "{count} askel",
    "steps_other": "{count} askelta",
    "blocks_one": "{count} palikka",
    "blocks_other": "{count} palikkaa",
    "stars_one": "{count} tähti",
    "stars_other": "{count} tähteä",
    "place": "Lisää palikoita",
    "atEnd": "Loppuun",
    "insideRepeat": "Toiston {number} sisään",
    "insideIf": "Jos-lohkon {number} sisään",
    "insideElse": "Muuten-lohkon {number} sisään",
    "readyFirst": "Pieni askel. Lisää eteenpäin-palikka ja mennään!",
    "ready": "Minne mennään? Tee suunnitelma vihkoosi.",
    "back": "Takaisin alussa. Palikkasi ovat valmiina uuteen yritykseen.",
    "empty": "Lisää ensin palikka vihkoosi.",
    "win": "Löysit tien!",
    "winCover": "Valaisit polun!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Mikä seikkailu!",
    "simpler": "Onnistuisiko vähemmillä palikoilla?",
    "complete": "Reitti valmis! Parhaat tähtesi on tallennettu.",
    "next": "Seuraava reitti",
    "allWorlds": "Lisää seikkailuja",
    "replay": "Pelaa uudelleen",
    "shortGoal": "Melkein! Lisää vielä palikoita päästäksesi tähden luo.",
    "shortGem": "Melkein! Lisää vielä palikoita päästäksesi jalokiven luo.",
    "shortCover": "Jotkin ruudut ovat vielä pimeitä. Miten pääsemme niihin?",
    "checking": "Katsotaan polkua…",
    "paused": "Pysäytetty. Pelaa aloittaa alusta.",
    "going": "Matkaan!",
    "stepped": "Askeleen lähempänä. Jatka painamalla Yksi askel tai Pelaa.",
    "clueCover": "Aloita reunasta ja kulje koko kuvio. Hypyllä voit ohittaa ruudun sytyttämättä sitä.",
    "clueCondition": "Katso edessä olevaa polkua. Ehto auttaa tutkimusmatkailijaa valitsemaan toiminnon.",
    "clueRepeat": "Mitkä askeleet toistuvat? Laita kuvio toistopalikan sisään.",
    "clueForward": "Eteenpäin seuraa tutkimusmatkailijan katsetta. Laske ruudut tähteen asti.",
    "clueGem": "Eteenpäin seuraa tutkimusmatkailijan katsetta. Laske ruudut jalokiveen asti.",
    "clueTurn": "Kääntyminen vaihtaa suunnan liikkumatta. Seuraa polkua sormellasi.",
    "mapNote": "Valitse reitti. Parhaat tähtesi säilyvät.",
    "mapLevel": "Reitti {number}: {name}. {stars}.",
    "locked": "Avaa tämä reitti suorittamalla edellinen.",
    "soundBlocked": "Kuule seikkailun äänet painamalla äänipainiketta.",
    "clearTitle": "Aloitetaanko uusi sivu?",
    "clearNote": "Tämän reitin palikat poistetaan. Kumoa voi palauttaa ne.",
    "keep": "Säilytä palikkani",
    "clearConfirm": "Poista palikat",
    "fresh": "Uusi sivu. Minne seuraava suunnitelmasi vie meidät?",
    "localProgress": "Edistymisesi tallennetaan tälle laitteelle.",
    "helpBuild": "Tee suunnitelma",
    "helpBuildText": "Vedä palikat vihkoon ja yhdistä ne tai lisää palikka napauttamalla sitä. Valitse toiston sisään lisääminen, kun haluat askeleita silmukkaan.",
    "helpTurn": "Seuraa tutkimusmatkailijaasi",
    "helpTurnText": "Eteenpäin seuraa katsetta. Vasen ja oikea kääntävät paikallaan. Hyppy kulkee kaksi ruutua.",
    "helpTry": "Kokeile, katso ja yritä uudelleen",
    "helpTryText": "Kokeile suunnitelmaa painamalla Pelaa tai suorita yksi ohje painamalla Yksi askel. Kaareva nuoli palaa alkuun ja säilyttää palikat.",
    "helpWorlds": "Jokaisella seikkailulla on tavoite",
    "helpWorldsText": "Etsi jalokivi Viidakossa. Sytytä jouluseikkailussa jokainen vapaa laatta kerran. Tee Temppelissä ja Egeanmerellä korjaukset ja näkyvät tehtävät ja saavuta uloskäynti.",
    "noTrail": "Siellä ei ole polkua! Kokeile kääntyä ensin.",
    "broken": "Tuo silta on rikki. Voitko hypätä sen yli?",
    "blocked": "Jokin tukkii tien. Kokeile hyppyä tai toista reittiä.",
    "alreadyLit": "Tuo ruutu on jo valaistu. Käy jokaisessa ruudussa vain kerran.",
    "loopError": "Suunnitelma toistuu loputtomasti. Kokeile muuttaa silmukkaa.",
    "repeatError": "Valitse toistomäärä väliltä 1–99.",
    "unsupported": "Poista palikka, jota ei tueta, ja yritä uudelleen.",
    "connect": "Yhdistä palikat yhdeksi ketjuksi ja paina Pelaa.",
    "path": "polku",
    "backpack": "Reppu",
    "templeGems": "Temppelin jalokivet",
    "gemsCollected": "Jalokivet: {count} / {total}",
    "gemsReady": "Kaikki jalokivet on kerätty!",
    "aegeanTitle": "Egeanmeren salaisuudet",
    "harbour": "Satama",
    "aegeanDescription": "Tutki satamaa: korjaa pisteitä, käytä aliohjelmia uudelleen ja anna jokaiselle työtilaukselle luku.",
    "templeBetaNote": "Beta · Pulmia ja oppitunteja uudistetaan",
    "aegeanBetaNote": "Beta · Sataman 3 ensimmäistä tasoa",
    "seasonal": "Kausiseikkailu",
    "choosePreview": "Valitse esikatselutaso",
    "repairs": "Korjaukset",
    "reachExit": "Saavuta uloskäynti",
    "taskRequirements": "Tehtävän tavoitteet",
    "lessonGuided": "Ohjattu harjoitus · täydennä annettu ohjelma",
    "lessonRepair": "Virheenetsintä · korjaa annettu ohjelma",
    "lessonChallenge": "Haaste · tee oma ohjelmasi",
    "acc_define_parameter": "Aliohjelma",
    "acc_call_argument": "Kutsu aliohjelmaa",
    "acc_repeat_parameter": "Toista syötteen mukaan",
    "parameter": "parametri",
    "argument": "anna",
    "callInput": "Tämän kutsun syöte",
    "inputWaiting": "Suorita ohjelma tai yksi käsky kerrallaan nähdäksesi seuraavan syötteen.",
    "argumentMismatch": "Parametrillinen aliohjelma tarvitsee kutsun, jossa on luku. Ilman parametria käytetään tavallista kutsua.",
    "unsetParameter": "Käytä parametria vain sen vastaanottavassa aliohjelmassa. Parametrit ovat erillään jaetusta muistista.",
    "memoryObjective": "Tarkista korjausloki ja uloskäynnin vaatimukset. Jokainen ne täyttävä ohjelma hyväksytään.",
    "gate": "Tie on tukossa. Tarkista keskeneräiset korjaukset.",
    "noPickup": "Seiso työkalun kohdalla ennen sen poimimista.",
    "creditLead": "Tiimin johtaminen ja ohjelmistokehitys",
    "creditArt": "Kuvitus ja ympäristöt",
    "creditAnimation": "Animaatio",
    "creditUX": "Käyttöliittymän ja käyttökokemuksen suunnittelu",
    "creditDesign": "Pelisuunnittelu",
    "creditStory": "Tarinan kirjoittaminen",
    "creditAudio": "Musiikki ja äänitekniikka",
    "lightLamp": "Sytytä lamppu",
    "oilLamp": "Öljylamppu",
    "dustyStation": "pölyinen piste",
    "betaLabel": "Beta",
    "noLamp": "Seiso sammuneen lampun kohdalla ennen sen sytyttämistä.",
    "collected": "Työkalu kerätty · valmis käyttöön",
    "dustyPrompt": "Seiso pölyisellä asemalla ennen siveltimen käyttöä.",
    "lampMissing": "Kerää ensin öljylamppu. Katso reppuusi.",
    "recursiveRoutine": "Tämä aliohjelma kutsuu itseään. Käytä toista aliohjelmaa; rekursiiviset kutsut eivät ole vielä käytettävissä."
  },
  "content": {
    "jungle.title": "Viidakkoretki",
    "jungle.description": "Seuraa polkua kadonneeseen temppeliin.",
    "jungle-1": "Ensiaskeleet",
    "jungle-2": "Hieman pidemmälle",
    "jungle-3": "Kulman ympäri",
    "jungle-4": "Vaihda suuntaa",
    "jungle-5": "Seuraa polkua",
    "jungle-6": "Uusi reitti",
    "jungle-7": "Uusia polkuja",
    "jungle-8": "Viidakon risteys",
    "jungle-9": "Löydä tiesi",
    "jungle-10": "Ajattele eteenpäin",
    "jungle-11": "Pitkä polku",
    "jungle-12": "Mutkainen reitti",
    "jungle-13": "Rohkea hyppy",
    "jungle-14": "Kuvioita ilmestyy",
    "jungle-15": "Toista rytmi",
    "jungle-16": "Valitse polku",
    "jungle-17": "Katso ennen hyppyä",
    "jungle-18": "Lue polkua",
    "jungle-19": "Nokkela kiertotie",
    "jungle-20": "Puiden latvusten alla",
    "jungle-21": "Sillanrakentaja",
    "jungle-22": "Joen tuolla puolen",
    "jungle-23": "Tutki raunioita",
    "jungle-24": "Kivi ja puu",
    "jungle-25": "Suurempi hyppy",
    "jungle-26": "Seuraa vihjeitä",
    "jungle-27": "Korkeammalle",
    "jungle-28": "Jatka tutkimista",
    "jungle-29": "Kiemurtelevat polut",
    "jungle-30": "Salainen puutarha",
    "jungle-31": "Piilotetut kuviot",
    "jungle-32": "Muinaiset polut",
    "jungle-33": "Viimeiset käännökset",
    "jungle-34": "Kohti temppeliä",
    "jungle-35": "Melkein perillä",
    "jungle-36": "Kadonnut temppeli",
    "winter.title": "Talvipolku",
    "winter.description": "Sytytä valo jokaiseen jalanjälkeen.",
    "winter-1": "Askeleita lumessa",
    "winter-2": "Toinen suunta",
    "winter-3": "Jäätyneet kulmat",
    "winter-4": "Pitkä kiertotie",
    "winter-5": "Lumihiutale",
    "winter-6": "Talvisilmukat",
    "winter-7": "Jään tutkija",
    "winter-8": "Mutkia ja käännöksiä",
    "winter-9": "Jäinen logiikka",
    "winter-10": "Kuvioiden löytäjä",
    "winter-11": "Polun mestari",
    "winter-12": "Talven ihme",
    "temple.title": "Kadonnut temppeli",
    "temple.description": "Neljäkymmentä yhdistettyä huonetta. Korjaa taivaallinen laite työkaluilla, muistilla ja omilla aliohjelmilla."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Roskakori on tyhjä",
    "OPEN_TRASH": "Avaa roskakori",
    "BLOCK_LABEL_BEGIN_STACK": "Ketjun alku",
    "WORKSPACE_LABEL_1_STACK": "1 palikkaketju",
    "WORKSPACE_LABEL_MANY_STACKS": "Palikkaketjuja: %1",
    "ARIA_TYPE_FIELD_NUMBER": "luku",
    "ARIA_TYPE_FIELD_DROPDOWN": "pudotusvalikko",
    "ARIA_TYPE_FIELD_IMAGE": "kuva",
    "WORKSPACE_LABEL_PLAIN": "Minun vihkoni",
    "FIELD_LABEL_EDIT_PREFIX": "Muokkaa: %1",
    "BLOCK_LABEL_HAS_INPUT": "sisältää syötteen",
    "BLOCK_LABEL_HAS_INPUTS": "sisältää syötteitä",
    "BLOCK_LABEL_HAS_BRANCHES": "haaroja: %1",
    "FIELD_LABEL_OPTION_INDEX": "Vaihtoehto %1",
    "INPUT_LABEL_EMPTY": "Tyhjä",
    "BLOCK_LABEL_DISABLED": "poissa käytöstä",
    "BLOCK_LABEL_COLLAPSED": "kutistettu",
    "BLOCK_LABEL_BEGIN_PREFIX": "Alku: %1",
    "INPUT_LABEL_END_STATEMENT": "Loppu: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "teksti",
    "ARIA_TYPE_FIELD_INPUT": "syöte",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "syötteen nimi",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "aliohjelman nimi"
  }
}
